export const en = {
  "actions": "Actions",
  "add": "Add",
  "age": "Age",
  "age.month": "m",
  "age.year": "y",
  "apply": "Apply",
  "birthday": "Birthday",
  "born": "Born",
  "cancel": "Cancel",
  "close": "Close",
  "collapsedText.hide": "Hide",
  "collapsedText.show": "Show more",
  "confirm": "Confirm",
  "confirmClose.accept": "Discard",
  "confirmClose.body": "If you discard your inputs, your edits will not be saved.",
  "confirmClose.title": "Discard changes?",
  "copy": "Copy",
  "count.items": "{count} items",
  "create": "Create",
  "danish": "Danish",
  "datePicker.label": "Date",
  "dateRangePicker.label": "Date range",
  "delete": "Delete",
  "details": "Details",
  "download": "Download",
  "dutch": "Dutch",
  "edit": "Edit",
  "empty": "Empty",
  "emptyState.items": "data",
  "emptyState.noItems": "No {itemName}",
  "english": "English",
  "entries.add": "Add {entry}",
  "entries.add.another": "Add another {entry}",
  "error.400.message": "Invalid request",
  "error.401.message": "Not authorized",
  "error.403.message": "Insufficient access",
  "error.404.message": "Not found",
  "error.408.message": "Timeout",
  "error.fallback.message": "An error occurred",
  "false": "No",
  "filter": "Filter",
  "filterFormButtons.reset": "Reset",
  "filterFormButtons.search": "Search",
  "finish": "Finish",
  "form.showOnlyChanges": "Show only changes",
  "genericUnavailableAction": "Action unavailable due to current data/rights.",
  "input.clear": "Clear",
  "input.nothingFound": "No results found",
  "input.startToAdd": "Start typing to add…",
  "input.startTyping": "Start typing to search…",
  "inputWrapper.bigger": "The new value is bigger than the existing value.",
  "inputWrapper.defaultValueTooltip": "Click to revert to the default value",
  "inputWrapper.different": "The new value is different from the existing value.",
  "inputWrapper.existingValueTooltip": "Click to revert to the existing value",
  "inputWrapper.smaller": "The new value is smaller than the existing value.",
  "markdownViewer.media.unsupportedFormat": "Unsupported media format. Please use MP4 for video assets, and PNG or JPG/JPEG encoding for images.",
  "markdownViewer.video.unsupported": "Your browser does not support this video format.",
  "months": "{months} months",
  "next": "Next",
  "no": "No",
  "none": "None",
  "notFound": "Not found",
  "open": "Open",
  "option.noDataAvailable": "No data available",
  "previous": "Previous",
  "retry": "Retry",
  "save": "Save",
  "search": "Search",
  "select.label": "Select",
  "select.noResults": "No results found",
  "select.pleaseTypeToSearch": "Please type to search",
  "signout": "Sign out",
  "table.filter.dateRangeTitle": "Date range",
  "table.filter.maxTitle": "Max",
  "table.filter.minTitle": "Min",
  "table.filter.toggleAll": "Toggle all",
  "total": "Total",
  "true": "Yes",
  "undo": "Undo",
  "upload": "Upload",
  "validation.between": "Please enter a value between {min} and {max}",
  "validation.email": "Please enter a valid email address",
  "validation.invalidDate": "Please enter a valid date",
  "validation.length": "The value must be at least {length} characters long",
  "validation.max": "Please enter a value less than or equal to {max}",
  "validation.min": "Please enter a value greater than or equal to {min}",
  "validation.required": "Please enter a value",
  "year": "{years} year",
  "years": "{years} years",
  "yes": "Yes",
} as const
